


















import { Component, Vue, Prop } from 'vue-property-decorator';
import MaterialItemForm from '@/components/forms/MaterialItemForm.vue';

@Component({
    components: {
        MaterialItemForm
    }
})
export default class ItemAdd extends Vue {
}
